<template>
  <div>
    <Form label-position="top" class="pd-r-5 pd-l-5">
      <FormItem label="Сургалт">
        <Select v-model="srch.courseId" @change="loadBox" filterable clearable>
          <Option
            v-for="(t, i) in filterData.tasks"
            :value="t.id"
            :key="i"
            :label="`${i + 1}.) ${t.task}`"
            >{{ i + 1 }}.) {{ t.task }} ({{
              t.dueStartDate | moment("YYYY.MM.DD")
            }}-{{ t.dueDate | moment("YYYY.MM.DD") }})</Option
          >
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="srch.id" filterable clearable>
          <Option
            v-for="(t, i) in filterData.boxes"
            :value="t.id"
            :key="i"
            :label="`${i + 1}.) ${t.task}`"
            >{{ i + 1 }}.) {{ t.task }}</Option
          >
        </Select>
      </FormItem>
    </Form>
    <hr class="m-t-sm m-b-sm" />
    <div class="pd-l-5 pd-r-5">
      <Button
        @click="$emit('on-seach', srch)"
        icon="md-refresh"
        long
        type="primary"
        >Ачааллах</Button
      >
    </div>
  </div>
</template>

<script>
var _ = require("lodash");
import { request } from "@/api/all";
import { mapActions } from "vuex";
import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  //Input,
  FormItem,
  //DatePicker,
  //Divider,
  //InputNumber,
  Select,
  //OptionGroup,
  Option,
  Button
  //Notification
  //Checkbox,
  //RadioGroup,
  //Radio
} from "element-ui";

export default {
  components: {
    Form,
    //Input,
    FormItem,
    //DatePicker,
    //Divider,
    //InputNumber,
    Select,
    //OptionGroup,
    Option,
    Button
  },
  data() {
    return {
      srch: {
        courseId: null,
        id: null
        // p2: "",
        // startDate: null,
        // endDate: null
      },
      coreSearchModel: {},
      filterData: {
        tasks: [],
        boxes: []
      }
    };
  },
  methods: {
    ...mapActions(["handleLoading"]),
    loadBox(e) {
      this.handleLoading({ isLoading: true });

      request({
        api: { method: "get", url: "task/taskInheritedDetail" },
        params: {
          id: e
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          let tb = res.data.task.b;
          if (tb.length > 0) {
            if (tb.filter(b => b.ot == 114).length > 0) {
              let bid = tb.filter(b => b.ot == 114)[0].id;

              request({
                api: { method: "post", url: "taskCore/coreBoxInTaskList" },
                data: {
                  id: bid,
                  skip: 0,
                  size: 500
                },
                store: this.$store
              }).then(resb => {
                if (resb != false) {
                  this.filterData.boxes = resb.data.tasks;
                }
              });
            }
          }
        }
      });
    }
  },
  mounted() {
    let _pid = 0;
    let proj = this.$store.state.app.groupDefaultProjects.filter(
      x => x.objectTypeId == 115
    );
    if (proj.length) {
      _pid = proj[0].id;
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          projectId: _pid,
          skip: 0,
          size: 2000,
          id: 0,
          model: this.coreSearchModel
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res.data.tasks.length > 0)
          this.filterData.tasks = _.orderBy(res.data.tasks, ["id"], ["desc"]);
        else
          this.filterData.tasks = [
            { id: 0, task: "Байгууллагын админд хандана уу" }
          ];
      });
    }
  }
};
</script>
